/* ============================================================
   Polling intervals — one place to tune the whole app.
   ------------------------------------------------------------
   User is on Cloudflare Workers Paid, so vendor calls and KV
   writes are metered generously. The visibility-aware hook
   (useVisiblePoll) pauses automatically when the tab is hidden,
   so a laptop in the background doesn't burn quota.

   If you need to reduce vendor load, bump these numbers up.
   ============================================================ */

/** How often the watchlist refetches quotes+leans while visible.
 *  Backend outer-cache TTL should be ≤ this so polls actually see
 *  fresh data instead of the cached snapshot. */
export const WATCHLIST_POLL_MS = 25_000;

/** How often DetailPage refreshes just the top-of-page quote (price
 *  + change %). The heavy FMP fan-out (indicators, candles, news) is
 *  NOT re-polled — that stays fetch-on-open. */
export const DETAIL_QUOTE_POLL_MS = 25_000;

/** How long a per-row "flash" background stays visible after a
 *  price change. Short enough not to be annoying, long enough to
 *  catch the user's eye. */
export const FLASH_DURATION_MS = 900;
